exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-container[data-v-404b7273] {\r\n    text-align: center;\r\n    margin-top: 50px;\r\n    font-size: 1.2rem;\r\n    font-weight: bold;\n}\n.survey-unavailable[data-v-404b7273] {\r\n    text-align: center;\r\n    margin-top: 50px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-404b7273","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/surveys/SurveyTest.vue
// module id = 3003
// module chunks = 38 58